const MARK_STYLE = {
  background: '#D49A2A30',
  color: '#263238',
  borderRadius: 2,
  padding: '0 2px',
};

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function highlightText(text, query) {
  const source = String(text ?? '');
  const needle = String(query ?? '');
  if (!needle) return [source];

  const matcher = new RegExp(`(${escapeRegExp(needle)})`, 'giu');
  return source.split(matcher).filter(Boolean).map((part, index) => (
    part.localeCompare(needle, undefined, { sensitivity: 'accent' }) === 0
      ? <mark key={`${index}-${part}`} style={MARK_STYLE}>{part}</mark>
      : part
  ));
}
